"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalEnvironment = exports.isStagingEnvironment = exports.isProductionEnvironment = exports.environment = exports.getEnvironment = void 0;
function normalizeEnvironment(value) {
    const normalizedValue = value?.toLowerCase().slice(0, 4);
    if (normalizedValue === "prod")
        return "production";
    if (normalizedValue === "stag")
        return "staging";
    if (normalizedValue === "loca")
        return "local";
    if (normalizedValue === "deve")
        return "local";
    if (normalizedValue === "test")
        return "local";
    return null;
}
function getProcessEnv() {
    if (typeof process === "undefined")
        return {};
    return {
        ...process.env,
        ENVIRONMENT: process.env.ENVIRONMENT,
        NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
        REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
        VITE_ENVIRONMENT: process.env.VITE_ENVIRONMENT,
    };
}
function getViteEnv() {
    return {
        VITE_ENVIRONMENT: typeof __VITE_ENVIRONMENT__ === "undefined"
            ? undefined
            : __VITE_ENVIRONMENT__,
    };
}
function getEnvironmentValue(env) {
    const resolvedEnv = env ?? getProcessEnv();
    const viteEnv = env ? {} : getViteEnv();
    return (viteEnv.VITE_ENVIRONMENT ??
        resolvedEnv.ENVIRONMENT ??
        resolvedEnv.NEXT_PUBLIC_ENVIRONMENT ??
        resolvedEnv.REACT_APP_ENVIRONMENT ??
        resolvedEnv.VITE_ENVIRONMENT ??
        (typeof __APP_ENV__ === "undefined" ? undefined : __APP_ENV__));
}
function getEnvironment(env) {
    return normalizeEnvironment(getEnvironmentValue(env)) ?? "local";
}
exports.getEnvironment = getEnvironment;
exports.environment = getEnvironment();
exports.isProductionEnvironment = (() => getEnvironment() === "production")();
exports.isStagingEnvironment = (() => getEnvironment() === "staging")();
exports.isLocalEnvironment = (() => getEnvironment() === "local")();
// redeploy 2
//# sourceMappingURL=environment.js.map